import { createAsyncThunk } from "@reduxjs/toolkit";

import axiosChargebee from "../utils/chargebee";
import axiosHubspot from "../utils/hubspot";
import axiosTenant from "../utils/tenant";

import {
  getCustomer
} from "../../utils/helpers";

import {
  notification
} from "../actions";

export const getCustomerSubscriptions = createAsyncThunk("getCustomerSubscriptions", async (payload, thunkAPI) => {
  let userId = getCustomer();
  try {
    let response = await axiosChargebee.get(`/v1/users/${userId}/subscription`);
    if (response && response.data && response.data.success) {
      return response.data
    } else {
      return []
    }
  } catch (e) {
    thunkAPI.dispatch(notification({ title: `We are having some issues`, message: `${e.message}`, type: `error` }));
    console.log("Error:", e)
  }
})